/**
 * UnlockStatus - Shows level unlock progress
 */
import { Lock, Check } from 'lucide-react';
import { LEVEL_LABELS } from '@/lib/api';

export default function UnlockStatus({ nextLevel, unlockStatus }) {
  if (!nextLevel || !unlockStatus) return null;

  const isUnlocked = unlockStatus.unlocked;

  return (
    <div className={`rounded-2xl p-3 sm:p-4 mb-4 sm:mb-6 border ${isUnlocked ? 'bg-[#10B981]/10 border-[#10B981]/30' : 'bg-[#F59E0B]/10 border-[#F59E0B]/30'}`}>
      <div className="flex items-center gap-2 sm:gap-3">
        {isUnlocked ? <Check className="w-4 sm:w-5 h-4 sm:h-5 text-[#10B981]" /> : <Lock className="w-4 sm:w-5 h-4 sm:h-5 text-[#F59E0B]" />}
        <p className="text-xs sm:text-sm">
          {isUnlocked
            ? <span className="text-[#10B981] font-bold">{LEVEL_LABELS[nextLevel]} freigeschaltet</span>
            : <span className="text-[#F59E0B]">Noch <span className="font-bold">{unlockStatus.missingCorrect} richtige</span> bis {LEVEL_LABELS[nextLevel]}</span>
          }
        </p>
      </div>
    </div>
  );
}
